import {AsyncCdkDialog, CdkDialogConfig} from '@aipb/shared/dialog';
import {inject, Injectable} from '@angular/core';
import {VirtualKeyboardDialogComponent} from './virtual-keyboard-dialog.component';
import {VirtualKeyboardDialogDataModel} from './models/virtual-keyboard-dialog-data.model';
import {Overlay} from "@angular/cdk/overlay";
import {DialogRef} from "@angular/cdk/dialog";

@Injectable({
  providedIn: 'root'
})
export class VirtualKeyboardDialogService extends AsyncCdkDialog<VirtualKeyboardDialogComponent, VirtualKeyboardDialogDataModel> {
  private overlay = inject(Overlay);
  private ref: DialogRef<VirtualKeyboardDialogDataModel, VirtualKeyboardDialogComponent>;

  override async open(
    data: VirtualKeyboardDialogDataModel,
    config: CdkDialogConfig = {}
  ): Promise<DialogRef<VirtualKeyboardDialogDataModel, VirtualKeyboardDialogComponent>> {
    this.close();

    const component = await this.loadComponent();

    this.ref = this.dialog.open(component, {
      ...this.dialogConfig(),
      ...config,
      data
    });

    return this.ref;
  }

  close() {
    if (!this.ref) return;

    this.ref.close();
    this.ref = null;
  }

  async loadComponent() {
    return import('./virtual-keyboard-dialog.component').then((r) => r.VirtualKeyboardDialogComponent);
  }

  override dialogConfig(): CdkDialogConfig {
    return {
      minWidth: '50vw',
      hasBackdrop: false,
      positionStrategy: this.overlay.position().global().bottom('16px').centerHorizontally()
    };
  }
}
